var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_vm._v("\n  暂无数据\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }